import dataSecurity from '../../../assets/img/data-security.png';
import net from '../../../assets/img/net.png';
import locker from '../../../assets/img/locker.png';
import dataBase from '../../../assets/img/database.png';
import highQuality from '../../../assets/img/highQuality.svg';
import effectiveProtection from '../../../assets/img/effectiveProtection.svg';
import {
  serviceOne,
  serviceTwo,
  serviceThree,
  serviceFour,
  serviceFive,
  serviceSix,
} from './text';

const serviceData = [
  {
    imageSrc: net,
    title: 'Cloud Infrastructure',
    description: serviceOne,
  },
  {
    imageSrc: dataBase,
    title: 'Container Orchestration',
    description: serviceTwo,
  },
  {
    imageSrc: effectiveProtection,
    title: 'CI/CD Pipelines',
    description: serviceThree,
  },
  {
    imageSrc: locker,
    title: 'Infrastructure as Code',
    description: serviceFour,
  },
  {
    imageSrc: dataSecurity,
    title: 'Cloud Monitoring',
    description: serviceFive,
  },
  {
    imageSrc: highQuality,
    title: 'Security & Compliance',
    description: serviceSix,
  },
];

export default serviceData;
